var _rect, _g, _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 222,
    fill: "#181818"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "50% 50%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.5 81.3 L 27.4 63.9 C 25.6 57.6 29.9 51 36.5 50.3 L 55.6 48 C 59.9 47.5 63.4 44.6 64.7 40.6 L 70.5 22.5 C 72.7 15.6 80.9 12.8 86.9 16.9 L 102.9 27.7 C 106.6 30.2 111.4 30.2 115.1 27.7 L 130.6 17.2 C 136.7 13.1 145.1 16.1 147.1 23.2 L 151.6 39.3 C 152.9 44 157.2 47.2 162.1 47.2 H 185.3 C 192.7 47.2 197.9 54.3 195.5 61.3 L 188.9 80.9 C 187.4 85.5 189.1 90.5 193.1 93.2 L 207.3 102.8 C 213.6 107 213.6 116.3 207.3 120.5 L 192 130.9 C 188.5 133.2 186.7 137.3 187.4 141.4 L 190.7 163.8 C 191.7 170.3 186.6 176.1 180 176.1 H 162 C 157.2 176.1 152.9 179.3 151.6 183.9 L 147.5 197.9 C 145.3 205.1 136.5 208 130.5 203.4 L 115.6 192 C 111.7 189 106.3 189 102.4 192 L 87 203.8 C 81.1 208.3 72.5 205.7 70.1 198.6 L 65 183.5 C 63.5 179.1 59.4 176.1 54.8 176.1 H 37.8 C 30.8 176.1 25.6 169.5 27.4 162.7 L 32.8 141.8 C 33.9 137.5 32.3 133 28.6 130.4 L 14.5 120.4 C 8.5 116.1 8.5 107.2 14.5 102.9 L 28.4 93.1 C 32.2 90.4 33.8 85.7 32.5 81.3 Z",
    fill: "url(#paint0_linear_12351_417)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    "transform-origin": "50% -50%",
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: 0,
    to: 360,
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 109.5,
    r: 68.5,
    fill: "#2f2f2f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 101.5 100 C 101.5 103.2 101.6 106.3 101.5 109.4 C 101.5 110.6 102 111.4 103.1 111.8 C 104.2 112.2 105.2 112.1 106 111.1 C 106.6 110.3 107.1 109.3 107.7 108.4 C 112.6 99.8 117.4 91.2 122.4 82.6 C 127 74.6 137.4 72.2 144.8 77.6 C 149.8 81.1 152 86.1 151.3 92.3 C 151 95.5 149.5 98.1 148 100.7 C 143.4 108.8 138.8 117 134.1 125.1 C 130.8 130.9 127.5 136.8 124.1 142.5 C 120.9 147.9 116 150.5 109.9 150.3 C 103.2 150 97.6 145.5 95.7 138.6 C 95.2 137 95.1 135.3 95.1 133.6 C 95 125.1 95.1 116.5 95.1 108 C 95.1 105.5 93.7 104.5 91.3 105.1 C 91 105.2 90.8 105.3 90.5 105.4 C 82 107.9 73.4 103.3 70.9 94.9 C 68.3 86.5 73.3 77.5 81.7 75.2 C 90.2 72.9 98.6 77.8 100.9 86.4 C 101.3 87.9 101.5 89.4 101.5 91 C 101.5 94 101.5 97 101.5 100 Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12351_417",
    x1: 9.99844,
    y1: 110.498,
    x2: 211.995,
    y2: 110.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#107f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2aff7f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.15438356.svg";
export { ForwardRef as ReactComponent };